import "./Taxononogramy.css";

const MAX_LABEL_LENGTH = 4;

export function TaxononogramyLabel(props: { label?: string }) {
  return !props.label ? (
    <td className="th">&nbsp;</td>
  ) : (
    <td className={`th ${props.label[0]}`}>{props.label.slice(1)}</td>
  );
}

export function TaxononogramyBig(props: {
  rows: string[];
  cols: string[];
  corner: string;
  solution?: string;
}) {
  const { rows, cols, corner, solution } = props;
  return (
    <table className="taxononogramy-big">
      <tbody>
        {rows.map((row, ri) => (
          <tr key={ri}>
            {Array.from({
              length: MAX_LABEL_LENGTH - row.split(" ").length,
            }).map((_, i) => (
              <TaxononogramyLabel key={i} />
            ))}
            {row.split(" ").map((label, li) => (
              <TaxononogramyLabel key={li} label={label} />
            ))}
            {cols.map((_, ci) => (
              <td
                className={
                  (ri + ci) % 2 == 0
                    ? "taxononogramy-white-cell"
                    : "taxononogramy-black-cell"
                }
                key={ci}
              >
                {solution?.split("/")[ri][ci]}
              </td>
            ))}
          </tr>
        ))}
        <tr>
          <td
            rowSpan={MAX_LABEL_LENGTH}
            colSpan={MAX_LABEL_LENGTH}
            className="th"
          >
            {corner}
          </td>
          {cols.map((col, ci) => (
            <TaxononogramyLabel key={ci} label={col.split(" ")[0]} />
          ))}
        </tr>
        {Array.from({ length: MAX_LABEL_LENGTH - 1 }).map((_, j) => (
          <tr key={j}>
            {cols.map((col, ci) => (
              <TaxononogramyLabel key={ci} label={col.split(" ")[j + 1]} />
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function TaxononogramySmall(props: {
  left: boolean;
  right: boolean;
  chars: string;
}) {
  const { chars } = props;
  const nCols = chars.length / 11;
  const rows = [];
  for (let ri = 0; ri < 11; ri++) {
    const row = [];
    for (let ci = 0; ci < nCols; ci++) {
      row.push(chars[ri * nCols + ci]);
    }
    rows.push(row);
  }
  return (
    <table>
      <tbody>
        {rows.map((row, ri) => (
          <tr key={ri}>
            {props.left ? (
              ri === 0 ? (
                <td></td>
              ) : (
                <td style={{ borderRight: "0.1em solid black" }}>{ri - 1}_</td>
              )
            ) : null}
            {row.map((ch, ci) => (
              <td
                key={ci}
                style={{
                  ...(ri === 0 || ri === rows.length - 1
                    ? { borderBottom: "0.1em solid black" }
                    : {}),
                  ...(props.right && ci === nCols - 1 && ri !== 0
                    ? { borderRight: "0.1em solid black" }
                    : {}),
                }}
              >
                {ri === 0 ? "_" : ""}
                {ch}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
